module.exports = __webpack_public_path__ + "img/GT.ShallowFoundation.StripFoundation.InSituConcreteTraditionalStrip1050mm.b14191d4.png";